import {FreeTrialProgram, relevantFTCDSRUrlParams} from '@/common/fko-utils';
import {getFTCDSRFormDataForSubmission, getFTCDSRFormFields} from '@/common/ftcDsrUtils';
import CommonRegistrationPage from '@/components/Forms/CommonRegistrationForm/CommonRegistrationPage';
import {tocaLocations, tocaLocationsWithoutWorkingMboSiteId} from '@/constants/locations';
import {memo} from 'react';

const locationsAllowed = [...tocaLocations, ...tocaLocationsWithoutWorkingMboSiteId]
  .filter((loc) => loc.ftcDsrSupported)
  .map((loc) => loc.hubspotName);

const FtcDsrRegistrationPage = memo(() => {
  return (
    <CommonRegistrationPage
      programName={FreeTrialProgram.FTC_DSR}
      locationsAllowed={locationsAllowed}
      formId={import.meta.env.VITE_HUBSPOT_FTC_DSR_CLASS_FORM_ID ?? ''}
      relevantUrlParams={relevantFTCDSRUrlParams}
      getFormFields={getFTCDSRFormFields}
      getHubspotFormDataForSubmission={getFTCDSRFormDataForSubmission}
    />
  );
});

FtcDsrRegistrationPage.displayName = 'FtcDsrClassForm';

export default FtcDsrRegistrationPage;
